import React, {useEffect} from "react";

import {userManager} from "../../managers/UserManager";
import {SelfHostedServer} from "./SelfHostedServer";
import {i18nFormat} from "../../lib/i18nFormat";
import {EmptyPageContent} from "../../components/EmptyPageContent";
import {urlToPage} from "@shared/lib/urlToPage";

export function SelfHostedServersPage() {
  const servers = userManager.getSelfHostedServers()

  useEffect(() => {
    Promise.resolve().then(async () => {
      await window.hyWebsite.cloudApi.refreshUser();
    }).catch(error => alert(error));
  }, [])

  if (servers.length === 0) {
    return (
      <EmptyPageContent
        glyph={"glyph-core-nas"}
        title={i18nFormat("shs.no-self-hosted-servers.title")}
        text={i18nFormat("shs.no-self-hosted-servers.description")}
        link={{
          url: urlToPage("homey-self-hosted-server"),
          text: i18nFormat("shs.no-self-hosted-servers.learn-more"),
        }}
      />
    )
  }

  return (
    <section className="account-page">
      <header className="account-page__header">
        <h1 className="account-page__title">{i18nFormat("shs.title")}</h1>
        <p className="account-page__text">{i18nFormat("shs.subtitle")}</p>
      </header>
      <div className="account-page__content">
        {servers.map(server => (
          <SelfHostedServer key={server.id} server={server}/>
        ))}
      </div>
    </section>
  );
}